<template>
  <div class="d-ib">
    <el-button
      type="primary"
      class="btn-main"
      icon="el-icon-search"
      @click="dialog = true"
    >
      Filters
    </el-button>
    <el-dialog title="Filters" :visible.sync="dialog" width="30%">
      <el-input type="text" v-model="channel" placeholder="Channel" />
      <el-input
        type="text"
        v-model="artist"
        placeholder="Artist"
        class="mt10"
      />
      <el-input type="text" v-model="track" placeholder="Track" class="mt10" />
      <el-select v-model="type" clearable filterable class="mt10">
        <el-option value="3" label="New"></el-option>
        <el-option value="1" label="Approved"></el-option>
        <el-option value="2" label="Rejected"></el-option>
      </el-select>
      <div slot="footer">
        <el-button type="danger" size="mini" @click="clear">
          Clear
        </el-button>
        <el-button type="primary" size="mini" @click="filter">
          Filter
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

export default {
  data() {
    return {
      dialog: false,
      channel: '',
      artist: '',
      track: '',
      type: ''
    }
  },

  methods: {
    ...mapActions('vcVideoTracksScanShorts', ['readShorts', 'setPageShorts']),
    ...mapMutations('vcVideoTracksScanShorts', ['setPageShorts']),
    ...mapActions('vcVideoTracksScanRegular', ['readRegular', 'setPageRegular']),
    ...mapMutations('vcVideoTracksScanRegular', ['setPageRegular']),
    ...mapMutations('vcVideoTrackScanFreeVideos', ['setPageVideo']),
    ...mapActions('vcVideoTrackScanFreeVideos', ['readFreeVideos']),

    filter() {
      this.setPageShorts(1)
      this.setPageRegular(1)
      this.setPageVideo(1)
      this.dialog = false
      let filter_data = {
        channel: this.channel,
        artist: this.artist,
        track: this.track,
        type: this.type
      }
      localStorage.setItem(
        'video_track_scan_filter',
        JSON.stringify(filter_data)
      )
      this.readShorts(filter_data)
      this.readRegular(filter_data)
      this.readFreeVideos(filter_data)
      this.filtersEmpty()
    },

    clear() {
      this.channel = ''
      this.artist = ''
      this.track = ''
      this.type = ''
      localStorage.removeItem('video_track_scan_filter')
    },

    filtersEmpty() {
      let ls = JSON.parse(localStorage.getItem('video_track_scan_filter'))
      if (ls) {
        const { page, page_size, ...active_filters } = ls

        let f = Object.values(active_filters).filter(function(n) {
          return n > 0 || n != ''
        })

        if (f != null && f.length) return false
      }

      return true
    }
  },

  created() {
    this.filtersEmpty()
  }
}
</script>
